var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "region-apply" },
    [
      _c("div", { staticClass: "a-title" }, [
        _vm._v(
          "申请人信息(" +
            _vm._s(_vm.isApplyForMyself ? "个人" : "他人") +
            "申请)"
        )
      ]),
      _c(
        "div",
        { staticClass: "a-form" },
        [
          _vm.isApplyForMyself
            ? [
                _c("div", { staticClass: "f-item" }, [
                  _c("span", { staticClass: "i-text" }, [_vm._v("申请人")]),
                  _c("span", { staticClass: "i-text" }, [
                    _vm._v(_vm._s(_vm.$_.get(_vm.info, "nickname")))
                  ])
                ]),
                _c("div", { staticClass: "f-item" }, [
                  _c("span", { staticClass: "i-text" }, [_vm._v("联系电话")]),
                  _c("span", { staticClass: "i-text" }, [
                    _vm._v(_vm._s(_vm.$_.get(_vm.info, "mobile")))
                  ])
                ])
              ]
            : [
                _c("div", { staticClass: "f-item" }, [
                  _c("span", { staticClass: "i-text" }, [_vm._v("联系电话")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.mobile,
                        expression: "form.mobile"
                      }
                    ],
                    staticClass: "i-input",
                    attrs: { placeholder: "请输入申请人电话" },
                    domProps: { value: _vm.form.mobile },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "mobile", $event.target.value)
                        },
                        _vm.searchInput
                      ]
                    }
                  })
                ]),
                _c("div", { staticClass: "f-item" }, [
                  _c("span", { staticClass: "i-text" }, [_vm._v("申请人")]),
                  _c("span", { staticClass: "i-text" }, [
                    _vm._v(_vm._s(_vm.$_.get(_vm.memberInfo, "nickname")))
                  ])
                ])
              ],
          _c("div", { staticClass: "f-item" }, [
            _c("span", { staticClass: "i-text" }, [_vm._v("申请地区")]),
            _c("span", { staticClass: "i-text i-text_region" }, [
              _vm._v(_vm._s(_vm.blockInfo.regionFullName))
            ])
          ]),
          _c("div", { staticClass: "f-item" }, [
            _c("span", { staticClass: "i-text" }, [_vm._v("上级推荐人")]),
            _c("span", { staticClass: "i-text" }, [
              _vm._v(
                _vm._s(
                  _vm.isApplyForMyself
                    ? _vm.$_.get(_vm.info, "parent.nickname")
                    : _vm.$_.get(_vm.memberInfo, "parent.nickname")
                )
              )
            ])
          ]),
          _c("div", { staticClass: "f-item" }, [
            _c("span", { staticClass: "i-text" }, [_vm._v("上级代理")]),
            _c("span", { staticClass: "i-text" }, [
              _vm._v(
                _vm._s(
                  _vm.isApplyForMyself
                    ? _vm.$_.get(_vm.info, "distributor.nickname")
                    : _vm.$_.get(_vm.memberInfo, "distributor.nickname")
                )
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "f-item",
              on: {
                click: function($event) {
                  _vm.popupShow = true
                }
              }
            },
            [
              _c("span", { staticClass: "i-text" }, [_vm._v("团队领导人")]),
              _c("div", [
                _c("span", { staticClass: "i-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.selectedLeader.name
                        ? _vm.selectedLeader.name
                        : "请选择"
                    )
                  )
                ]),
                !_vm.selectedLeader.name
                  ? _c("span", { staticClass: "iconfont icon-xiajiantou" })
                  : _vm._e()
              ])
            ]
          ),
          !_vm.isApplyForMyself
            ? _c("div", { staticClass: "f-item" }, [
                _c("span", { staticClass: "i-text" }, [_vm._v("提交人")]),
                _c("span", { staticClass: "i-text" }, [
                  _vm._v(_vm._s(_vm.$_.get(_vm.info, "nickname")))
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "a-btn" },
        [
          _c(
            "a-btn",
            {
              class: { btnDisabled: "active" },
              attrs: { type: "primary", size: "large" },
              on: { click: _vm.submitApply }
            },
            [_vm._v("提交申请")]
          )
        ],
        1
      ),
      _c(
        "van-popup",
        {
          style: { height: "50%" },
          attrs: { position: "bottom" },
          model: {
            value: _vm.popupShow,
            callback: function($$v) {
              _vm.popupShow = $$v
            },
            expression: "popupShow"
          }
        },
        [
          _c("group-leader-picker", {
            on: {
              confirm: _vm.confirmLeader,
              cancel: function($event) {
                _vm.popupShow = false
              }
            }
          })
        ],
        1
      ),
      _c("a-dialog", {
        attrs: {
          show: _vm.dialog.applyRes,
          title: _vm.applyRes.title,
          "sub-title": _vm.applyRes.subTitle,
          type: _vm.applyRes.type
        },
        on: { close: _vm.handelAdialogClose },
        scopedSlots: _vm._u([
          {
            key: "btns",
            fn: function() {
              return [
                _vm.applyRes.type == "error"
                  ? [
                      _c(
                        "a-btn",
                        {
                          attrs: { type: "primary", hollow: "" },
                          on: { click: _vm.handelAdialogClose }
                        },
                        [_vm._v("返回")]
                      ),
                      _c(
                        "a-btn",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.back()
                            }
                          }
                        },
                        [_vm._v("重新选择")]
                      )
                    ]
                  : [
                      _c(
                        "a-btn",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handelAdialogClose }
                        },
                        [_vm._v("返回")]
                      )
                    ]
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }